export default {
  ioStageSent: 'Sent to client',
  ioStageClientViewed: 'Client viewed',
  ioStageClientSigned: 'Client signed',
  ioStageSkyriseSent: 'Sent to Skyrise',
  ioStageSkyriseViewed: 'Skyrise viewed',
  ioStageSkyriseSigned: 'Skyrise signed',
  ioCancelTitle: 'Cancel this IO?',
  ioCancelPrompt: 'Cancelling withdraws "{{name}}" at the signing provider. This cannot be undone.',
  ioCancelPromptSigned: 'Cancelling marks "{{name}}" cancelled and removes its lines from the booking sheet. This cannot be undone.',
  ioCancelConfirmAction: 'Cancel IO',
  ioCancelDismiss: 'Keep it',
  ioCancelReasonLabel: 'Reason for cancelling',
  ioCancelReasonHint: 'Everyone who signed will be told the IO was cancelled and shown this reason.',
  ioCancelReasonRequired: 'Give a reason so the signers know why.',
  ioCancelReasonPlaceholder: 'e.g. Campaign pulled by the client before launch',
  ioCancelSignedWarningTitle: 'This IO has already been signed',
  ioCancelSignedWarningBody: 'The signed document stays in the signing service as a record of what was agreed — cancelling marks the IO cancelled in NRVE and removes its lines from the booking sheet. Check with the client and your account manager before continuing.',
  ioSenderSection: 'Who it comes from (optional)',
  ioSendAs: 'Send as',
  ioSendAsHint:
    'The client sees this person as the sender. Leave blank to send as yourself. Only addresses verified in BoldSign can be used.',
  ioSendAsPlaceholder: 'Send as yourself',
  ioCcSection: 'Who else gets a copy (optional)',
  ioCcPlaceholder: 'name@example.com — press Enter after each',
  ioCcEmails: 'CC email addresses',
  ioCcHint:
    'Copied on the IO when it is sent and again once signed. They receive it but cannot sign or change it.',
  ioCcInvalid: 'Not a valid email address: {{emails}}',
  historyEmpty: 'No status history recorded for this document yet.',
  mediaPlan: 'Media Plans',
  actions: 'Actions',
  addCampaignDetailsHere: 'Please add Campaign Details here.',
  addLineItem: 'Add line item',
  addFirstLineItem: 'Please add your first line item',
  addToTemplates: 'Add to Templates',
  allPlans: 'All Plans',
  back: 'Back',
  budget: 'Budget',
  buyingMetric: 'Buying Model',
  cancelLineItemCreationProcess:
    'Are you sure you want to close the line item creation process? You will lose all progress.',
  cancelLineItemEditingProcess:
    'Are you sure you want to close the line item editing process? You will lose all changes.',
  cancelMediaPlanCreationProcess:
    'Are you sure you want to close the Media Plan creation process? You will lose all progress.',
  cancelMediaPlanEditingProcess:
    'Are you sure you want to close the Media Plan editing process? You will lose all changes.',
  cancelModalTitle: 'Close without saving',
  channel: 'Channel',
  channelBudgetIsNotMet: 'The Total Budget is less than the Current budget.',
  channelCreated: 'Line item has been added successfully.',
  channelCreatedAsDraft: 'The channel has been saved as a draft.',
  channelHasBeenCreated: 'Line item has been created successfully.',
  channelHasBeenDeleted: 'Line item has been deleted successfully.',
  lineItemUpdated: 'Line item updated.',
  lineItemUpdateFailed: 'Could not update the line item.',
  lineItemFieldLocked: 'Change this from Edit — it affects how the line is priced.',
  channelHasBeenEdited: 'Your changes have been successfully saved.',
  country: 'Country',
  continue: 'Continue',
  createLineItem: 'Create line item',
  currency: 'Currency',
  dealsWithoutMediaPlans: 'Deals without media plans',
  dealId: 'Deal ID',
  dsp: 'DSP (Platform)',
  dspFee: 'DSP fee',
  dspFees: 'DSP Fees',
  dspFeeIncludedInRateCard: 'Included in rate-card buy rate (not applied again)',
  dspFeeIncludedShort: 'Included',
  rateSource: 'Rate source',
  rateCard: 'Rate card',
  package: 'Package',
  techFee: 'Tech fee',
  techFeePercentHint: 'Percentage of this channel’s spend on the plan. Amount is calculated automatically.',
  techFeeCommercialHint: 'Tech fee amount is calculated from the % entered on the previous step against this channel’s budgets on the plan.',
  feeBaseChannel: 'Fee base channel',
  feeBaseChannelHint: 'Tech fee is calculated as a % of this channel’s line budgets on the plan.',
  selectFeeBaseChannel: 'Select base channel',
  feePercent: 'Fee %',
  inputFeePercent: 'Enter fee %',
  techFeeBudgetHint: 'Amount is calculated from the fee % of this channel’s spend on the plan.',
  techFeeBudgetPlaceholder: 'Calculated automatically',
  techFeeFieldsRequired: 'Tech fee requires a fee %.',
  applyAgencyDiscount: 'Apply agency discount',
  applyAgencyDiscountHint: 'On by default. Turn off to exclude this line from the plan agency discount.',
  valueAdd: 'Value',
  valueAddHintValuePot: 'Value pot: taken off net after agency discount. % is of net.',
  valueAddHintAddedValue: 'Added value: increases gross; net revenue stays the same. % is of gross.',
  valueAddPercentMode: '%',
  valueAddTypeValuePot: 'Value pot',
  valueAddTypeAddedValue: 'Added value',
  value: 'Value',
  grossBudget: 'Gross budget',
  netBudget: 'Net budget',
  valueAddResultingGross: 'Gross after value',
  valueAddResultingNet: 'Net after value',
  selectPackage: 'Select package',
  packageMissingCpm: 'Selected package is missing Sell CPM / Buy CPM. Edit the package and save again.',
  buyingPoint: 'Buying Point',
  createMediaPlan: 'Create Media Plan',
  currentBudget: 'Current: ',
  deleteChannelModalDescription:
    'Are you sure you want to delete this Channel? This action cannot be undone.',
  deleteChannelModalTitle: 'Delete Channel',
  removeLineItem: 'Remove line item',
  removeLineItemTitle: 'Remove line item',
  removeLineItemHint:
    'This plan has an IO, so this line item may be booked. Removing it takes it off the booking database too. The signed IO is not changed and no new IO is raised. The line item is kept in this plan’s removed line items, with your name and reason.',
  removeLineItemReason: 'Reason for removing',
  removeLineItemReasonRequired: 'Say why this line item is being removed.',
  removeLineItemConfirm: 'Remove line item',
  lineItemRemoved: 'Line item removed from the plan and the booking database.',
  lineItemRemoveFailed: 'Could not remove the line item. Try again.',
  removedLineItemsTitle: 'Removed line items',
  removedLineItemsHint: 'Taken off this plan after it was booked. The signed IO still shows them.',
  removedLineItemsLine: 'Line item',
  removedLineItemsBudget: 'Budget',
  removedLineItemsFlight: 'Flight',
  removedLineItemsBy: 'Removed by',
  removedLineItemsAt: 'Removed',
  removedLineItemsReason: 'Reason',
  deleteMediaPlanModalDescription:
    'Are you sure you want to delete this Media Plan? This action cannot be undone.',
  deleteMediaPlanModalTitle: 'Delete Media Plan',
  edit: 'Edit',
  editLineItem: 'Edit line item',
  duplicateLineItem: 'Duplicate line item',
  editMediaPlan: 'Edit Media Plan',
  estimatedClicks: 'Estimated clicks',
  estimatedListens: 'Estimated listens',
  expectedMargin: 'Gross Profit %',
  grossMarginPercent: 'Gross Margin %',
  tradingDealPercent: 'Rebate',
  estimatedViews: 'Estimated views',
  flightDates: 'Flight dates',
  format: 'Format',
  impressions: 'Impressions',
  quantity: 'Quantity',
  inputBudget: 'Input budget',
  inputSellRate: 'Input sell rate',
  inputYourText: 'Input your text here',
  mediaPlanCreatedSuccessfully: 'Media Plan has been created successfully.',
  mediaPlanHasBeenDeleted: 'Media plan has been deleted successfully.',
  mediaPlanUpdatedSuccessfully: 'Media Plan has been updated successfully.',
  pleaseAddYourFirstMediaPlan: 'Please add your first Media Plan',
  product: 'Product',
  publisher: 'Publisher',
  save: 'Save',
  saveAsDraft: 'Save as draft',
  saveAsPDF: 'Save as .pdf',
  pdfDownloadFailed: 'Failed to download PDF.',
  pdfDownloadDisabledHint:
    'Save as PDF is only available when the media plan status is Ready and you have create permission.',
  selectBuyingMetric: 'Select buying model',
  selectChannel: 'Select channel',
  selectClient: 'Select a client',
  selectFormat: 'Select format',
  selectProduct: 'Select product',
  selectPublisher: 'Select publisher',
  selectTargetingDevice: 'Select targeting device',
  selectTargetingKPI: 'Select targeting KPI',
  skyrisePowered: 'International Data Source',
  targetingDetails: 'Targeting Details',
  targetingDevice: 'Targeting Device',
  targetingKPI: 'Targeting KPI',
  kpi: 'KPI',
  rateCardBenchmark: 'Benchmark',
  rateCardBenchmarkConflict:
    'Multiple rate cards define different benchmarks for this KPI. Use separate rate card rows per KPI (e.g. CTR and VTR) with one benchmark each.',
  noRateCardBenchmark: 'No benchmark on rate card for this KPI',
  templates: 'IO Templates',
  templatesLoadFailed: 'Failed to load templates.',
  templateDetailsLoadFailed: 'Failed to load template details.',
  raiseIo: 'Raise IO',
  template: 'Template',
  selectTemplate: 'Select a template',
  templateRequired: 'Please select a template.',
  recipientEmailHint: 'The client contact who signs the IO. They are emailed a link to sign it.',
  recipientNameHint: 'Shown on the signature block. Leave blank to use the email address.',
  recipientNamePlaceholder: 'Optional',
  documentNameHint: 'Used in the signing service and in the email the client receives.',
  documentName: 'Document name',
  documentNameRequired: 'Please enter a document name.',
  recipientEmail: 'Client email',
  recipientEmailRequired: 'Enter the email address the IO should be sent to.',
  recipientEmailInvalid: 'Please enter a valid email address.',
  recipientFirstName: 'Client first name',
  recipientLastName: 'Client last name',
  sendImmediately: 'Send document immediately',
  preview: 'Preview',
  ioPreparingPreview: 'Preparing preview…',
  ioPreviewFailed: 'Failed to prepare preview.',
  ioDownload: 'Download',
  ioPreviewTimeout: 'Preview is taking longer than expected. Please try again.',
  ioPreviewEmptyTitle: 'No document yet',
  ioPreviewEmptyHint: 'Choose a template and the insertion order your client will receive appears here.',
  ioPreviewLoading: 'Preparing preview…',
  ioSearchPlaceholder: 'Search by document name',
  ioRevoked: 'Insertion Order cancelled.',
  ioRevokeFailed: 'Could not cancel this Insertion Order.',
  ioRevokeConfirm: 'Cancel this Insertion Order? The signer will no longer be able to sign it.',
  ioPreviewTitle: 'IO preview',
  ioPreviewTemplate: 'Template',
  layoutTab: 'Layout',
  layoutTemplate: 'Template',
  layoutColumnsHeading: 'Columns',
  layoutPreviewTitle: 'Live preview',
  layoutPreviewPlan: 'Preview against plan',
  layoutBackToList: 'All templates',
  layoutDefaultTag: 'Default',
  layoutEnabledColumn: 'Show in Raise IO',
  layoutSetDefaultAction: 'Set as default',
  layoutDefaultSet: '{{name}} is now the default template.',
  templateSummaryTitle: 'Document settings',
  templateSummaryColumns: '{{visible}} of {{total}} columns on the document',
  templateSummaryHint: 'Tap a column to show or hide it on this IO. To change the template for every IO, edit it under IO Templates.',
  pricingTitle: 'Totals and tax',
  pricingCurrency: 'Currency',
  pricingDiscount: 'Discount on totals',
  pricingTaxFirst: 'VAT',
  pricingTaxSecond: 'Second tax',
  pricingAbsolute: 'Amount',
  pricingShowDiscount: 'Show discount row',
  pricingShowTax: 'Show tax row at 0%',
  pricingRowLabel: 'Row label',
  pricingLineDiscount: 'Allow per-line discount',
  layoutNewAction: 'Add Template',
  layoutNewTitle: 'Create IO template',
  layoutNewPlaceholder: 'e.g. IO - Managed - Acme',
  layoutCreated: 'Template created. It starts from the layout you were viewing.',
  layoutCreateFailed: 'Could not create the template. The name may already be in use.',
  layoutDeleteAction: 'Delete',
  layoutDeleteConfirm: 'Delete "{{name}}"? This cannot be undone.',
  layoutDeleted: 'Template deleted.',
  pandaDocTab: 'PandaDoc templates',
  layoutColumn: 'Column',
  layoutVisible: 'Show on IO',
  layoutWidth: 'Width',
  layoutOrder: 'Order',
  layoutMoveUp: 'Move up',
  layoutMoveDown: 'Move down',
  layoutSaved: 'Layout saved. New IOs will use it.',
  layoutSaveFailed: 'Could not save the layout. Please try again.',
  layoutReset: 'Layout restored to the default.',
  layoutResetAction: 'Restore default',
  layoutResetConfirm: 'Restore this layout to the default? Your changes will be lost.',
  layoutColumnCount: '{{visible}} of {{total}} columns shown on the document.',
  ioKindManaged: 'Managed',
  ioKindHybrid: 'Hybrid',
  ioKindData: 'Data',
  poModalTitle: 'PO number',
  poNumber: 'PO',
  poPerLineHint:
    'Set a PO for an individual line only where the client has raised one for it. A line left blank uses the number above.',
  poNumberLabel: 'PO number',
  poNumberPlaceholder: 'e.g. POBB15522',
  poNumberHelp: 'Can be added or changed after the IO is signed. Leave blank if this client does not issue POs.',
  poSaved: 'PO number saved.',
  poSavedAndSynced: 'PO number saved and booking data updated.',
  poSaveFailed: 'Could not save the PO number. Please try again.',
  ioDeleteConfirm: 'Delete the draft "{{name}}"? This cannot be undone.',
  ioDeleted: 'Draft IO deleted.',
  ioDeleteFailed: 'Could not delete this IO. Only drafts can be deleted.',
  ioFilterByStatus: 'Filter by status',
  ioNoResults: 'No IOs match your search or filter.',
  ioTotalDocuments: '{{count}} document',
  ioTotalDocuments_other: '{{count}} documents',
  ioPreviewGenerating: 'PandaDoc is still generating this PDF. This can take a few seconds.',
  ioRaisedSuccessfully: 'IO has been raised successfully.',
  ioRaiseFailed: 'Failed to raise IO.',
  ioStateSigned: 'Signed',
  ioStateAwaitingSignature: 'Awaiting signature',
  ioSignedOn: 'Signed {{date}}',
  ioRaisedOn: 'Raised {{date}}',
  ioWillBeReplaced: 'Will be replaced',
  ioReplaceHintSigned:
    'Raise a new IO in place of this one. The signed IO stays in force until the new one is signed; its bookings are then retired.',
  ioReplaceHintUnsigned:
    'Raise a new IO in place of this one. The current IO stays out for signature until the new one is signed.',
  ioCancelAction: 'Cancel this IO',
  ioStillNeeded: 'Still needed: {{fields}}',
  ioReadyToSend: 'Ready to send.',
  ioNeedsReplaceChoice: 'This plan already has a live IO — choose Replace to supersede it.',
  ioReplaceExisting: 'Replace',
  ioReplaceUndo: 'Undo',
  ioReplaceConfirmTitle: 'Replace the signed IO?',
  ioReplaceConfirmBody:
    'The signed IO stays in force until the new one is signed. Once it is, the previous IO is superseded and its bookings are retired.',
  ioInternalConfirmBody:
    'The client will not be sent this revision or asked to sign it. The booking database updates straight away and the previous IO is superseded.',
  ioReplaceConfirmOk: 'Raise replacement',
  ioRaisedReplacementSuccess: 'Replacement IO v{{version}} has been raised.',
  ioInternalRaisedSuccess:
    'IO v{{version}} recorded internally. The client has not been sent it, and the booking database is updated.',
  ioConflictNeedsReplace:
    'This media plan already has a live IO. Tick "Replace the existing IO" to supersede it.',
  ioVersionHistory: 'IO history',
  ioVersionLabel: 'v{{version}}',
  ioVersionSuperseded: 'Superseded',
  ioVersionLive: 'In force',
  ioDocumentSection: 'Document',
  ioRecipientSection: 'Who signs it',
  ioCountersignerSection: 'Who counter-signs it (optional)',
  countersignerEmail: 'Skyrise signatory email',
  countersignerFirstName: 'Skyrise signatory first name',
  countersignerLastName: 'Skyrise signatory last name',
  countersignerHint:
    'Leave blank to issue the IO without a Skyrise signature. If set, they sign after the client and the document completes only once both have signed.',
  insertionOrders: 'Insertion Orders',
  // Readable names for the signing provider's own status values, which are
  // otherwise shown verbatim as e.g. "InProgress".
  ioStatusDraft: 'Draft',
  ioStatusSent: 'Awaiting signature',
  ioStatusViewed: 'Viewed',
  ioBudgetChangedTitle: 'The signed IO no longer matches this deal',
  ioBudgetChangedBody:
    'The IO was signed for {{signed}} and the deal now says {{current}}. The booking still stands on what was signed — raise a replacement IO to bring the two back into line.',
  ioInternalOnly: 'Internal amendment — do not send to the client',
  ioInternalOnlyHint:
    'Use for a change the client has no part in, such as moving budget between line items. The booking database updates and the revision is recorded, but nobody is asked to sign anything.',
  ioPrismaSection: 'Client order',
  clientOrderAwaited: 'Client order awaited',
  clientOrderHeld: 'Client order held',
  prismaViewAction: 'View client order',
  prismaModalTitle: 'Confirm Prisma order',
  prismaModalHint:
    'Attaching the signed order confirms the booking — contractually it is us signing the client’s order, not them signing ours. The line items go to the booking database on confirmation.',
  prismaConfirmAction: 'Confirm Prisma order',
  prismaFileLabel: 'Signed Prisma order (PDF)',
  prismaUploadText: 'Click or drag the Prisma PDF here',
  prismaUploadHint: 'PDF only, up to 15MB.',
  prismaFileRequired: 'Attach the signed Prisma PDF to confirm the order.',
  prismaReferenceLabel: 'Prisma reference (optional)',
  prismaReferencePlaceholder: 'e.g. PRS-00123',
  prismaReleased: 'Order confirmed. The line items are now in the booking database.',
  prismaSavedNotReleased:
    'Order saved, but no IO has been raised for this plan yet, so there is no schedule to book. Raise the IO and confirm again.',
  prismaAlreadyUploaded: 'Already attached: {{fileName}}',
  prismaViewFile: 'View',
  prismaLinkFailed: 'Could not open the Prisma document. Try again.',
  prismaStorageUnavailable:
    'Prisma uploads are not configured in this environment. Ask an admin to set the storage credentials.',
  prismaFailed: 'Could not save the Prisma order. Try again.',
  ioRequiresPrisma: 'Client order required (Prisma / DocuSign)',
  ioRequiresPrismaHint:
    'Usually set automatically from the buying point. The client signs their own order rather than our IO, so the booking is confirmed when that signed order is attached.',
  ioPrismaNotRecorded:
    'The IO was raised, but the Prisma requirement was not saved. Set it on the media plan.',
  ioStatusCompleted: 'Signed',
  ioStatusSuperseded: 'Overwritten',
  ioAdvertiser: 'Advertiser',
  ioCampaign: 'Campaign',
  ioBudget: 'Budget',
  ioFlight: 'Flight',
  ioDealId: 'Deal',
  ioSupersededOn: 'Overwritten on',
  ioStatusDeclined: 'Declined',
  ioStatusRevoked: 'Cancelled',
  ioStatusExpired: 'Expired',
  ioListLoadFailed: 'Failed to load IO documents.',
  ioListEmpty: 'No IO documents yet. Raise an IO from a media plan to see it here.',
  ioSendConfirm: 'Send this IO to the recipient?',
  ioSentSuccessfully: 'IO has been sent successfully.',
  ioSendFailed: 'Failed to send IO.',
  ioSessionExpired: 'Your session has expired. Please sign in again to continue.',
  ioIntegrationUnavailable:
    'The IO service is unavailable right now. This looks like an integration issue rather than something you did — please contact support if it continues.',
  ioSignInAgain: 'Sign in again',
  ioTemplatesEmpty: 'No IO templates are available. Contact support to have one added in PandaDoc.',
  ioNoTemplates: 'No templates found',
  ioPoNumberWarning:
    'No PO Number set — the IO will show it blank. That is fine: POs can be added after signature and will flow through to the booking data.',
  version: 'Version',
  createdAt: 'Created',
  modifiedAt: 'Modified',
  name: 'Name',
  roles: 'Roles',
  fields: 'Fields',
  tokens: 'Tokens',
  pricingTables: 'Pricing tables',
  noneLabel: 'None',
  type: 'Type',
  assignedTo: 'Assigned to',
  emptyValue: '(empty)',
  tradingDealLabel: 'Trading deal',
  totalBudget: 'Total Budget',
  totalHardCosts: 'Total Hard Costs',
  hardCost: 'Hard Cost',
  totalBudgetShouldBeGreater: 'The total budget should be equal to or greater than',
  typeCampaignName: 'Type campaign name',
  sellRate: 'Sell Rate',
  agencyDiscount: 'Agency Discount',
  agencyDiscountRangeMessage: 'Agency discount must be between 0 and 100',
  channelDependenciesWarning:
    'Previously entered info is cleared since Rate Cards data was changed. Please enter the updated information about Channel or close the window to keep previously saved info.',
  budgetUpdateWarning:
    'The budget has been updated from Pipedrive. Please update existing Channels accordingly.',
  startDate: 'Start Date',
  endDate: 'End Date',
  noChangesToSave: 'There are no changes to save',
  noRateCardCoverage: 'No rate card exists for this channel — choose Package.',
  rateCardNotFoundForLineItem:
    'No matching rate card was found for this line item. Check that Channel, Product, Targeting KPI, and Format are filled in and exist together in Rate Cards, or switch to Package pricing.',
  pleaseFixErrors: 'Please fix next errors to save channel',
  lineItemValidationFailed:
    'Unable to save. This may be because the media plan budget is already fully allocated. Try reducing an existing line item budget first, or check that all required fields are filled.',
  kpiRequiredForLineItem:
    'Please select a KPI (Targeting KPI) before saving. KPI is required when using a Package.',
  productRequiredForLineItem:
    'Product is required but missing or invalid. When using a Package, it should be auto-filled. Please re-select the package or go back and ensure a package is chosen.',
  lineItemFieldRequired: 'Required field missing or invalid: {{field}}.',
  lineItemNotFound:
    'This line item could not be found on the server (it may have been deleted or only exists in an old data store). Delete the row from the list and add a new line item, or ask your admin to fix the media plan data.'
} as Record<string, string>;
